import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DomController } from '@ionic/angular';


interface Theme {
  name: string;
  styles: ThemeStyle[];
}

interface ThemeStyle {
  themeVariable: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class ThemeSwitcherService {

  private themes: Theme[] = [];
  private currentTheme: number = 0;

  constructor(private domCtrl: DomController, @Inject(DOCUMENT) private document) {

    this.themes = [
      {
        name: 'bespoke',
        styles: [
          { themeVariable: '--app-content', value: '#fff' },
          /* These Below 6 Variables are only used for background Colors of ion-header ion-content etc */
          { themeVariable: '--app-primary', value: '#E31837' },
          { themeVariable: '--app-secondary', value: '#000' },
          { themeVariable: '--app-secondary-dark', value: '#1a1a1a' },
          { themeVariable: '--app-tertiary', value: '#F4F4F4' },
          { themeVariable: '--app-dark', value: '#000' },
          { themeVariable: '--app-light', value: '#fff' },

          { themeVariable: '--app-text-primary', value: '#000' },
          { themeVariable: '--app-text-secondary', value: '#fff' },
          { themeVariable: '--app-text-dark', value: '#000' },
          { themeVariable: '--app-text-light', value: '#fff' },
          { themeVariable: '--app-text-light1', value: '#bfc1cb' },

          { themeVariable: '--app-btn-primary', value: '#000' },
          { themeVariable: '--app-btn-secondary', value: '#fff' },
          { themeVariable: '--app-btn-tertiary', value: '#e7e5e5' },
          { themeVariable: '--app-btn-light', value: '#fff' },


          { themeVariable: '--app-bdr-primary', value: '#EDF1F3' },
          { themeVariable: '--app-bdr-secondary', value: '#EDF1F3' },
          { themeVariable: '--app-bdr-tertiary', value: '#98989887' },
          { themeVariable: '--app-bdr-dark', value: '#000' },
          { themeVariable: '--app-bdr-light', value: '#fff' },
          { themeVariable: '--cp-subtext', value: '#000' },

          { themeVariable: '--app-active', value: '#1a1a1a' },
          { themeVariable: '--app-active2', value: '#FFC72C' },
          { themeVariable: '--app-active3', value: '#f9b401' },

          { themeVariable: '--app-warning', value: '#f47920' },
          { themeVariable: '--app-info', value: '#151827' },
          { themeVariable: '--app-primary-light', value: '#638c1c' },
          { themeVariable: '--app-black', value: '#1a1a1a' },
          { themeVariable: '--app-black1', value: '#030405' },
          { themeVariable: '--app-dark2', value: '#000000aa' },
          { themeVariable: '--app-light1', value: '#bfc1cb' },
          { themeVariable: '--app-light1-opacity', value: '#bfc1cb7a' },

          { themeVariable: '--app-gradient-bg-modal', value: 'linear-gradient(180deg, #1b1b1b,#000)' },
          { themeVariable: '--app-gradient-v', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)' },
          { themeVariable: '--app-gradient-h', value: 'linear-gradient(90deg, #FADB8D, #F2CF81, #CE9F50)' },
          { themeVariable: '--app-bar', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)' },
          // { themeVariable: '--app-primary', value: 'linear-gradient(200deg, #4a2267, #3a1e50, #1d0f29)' },

          { themeVariable: '--app-dashboard', value: '#41205A' },
          { themeVariable: '--app-subtext', value: '#fff' },
          // { themeVariable: '--app-active', value: '#70379B' },
          { themeVariable: '--app-accordianHeader', value: 'transparent' },
          { themeVariable: '--app-card1', value: 'transparent' },
          { themeVariable: '--app-primary-default', value: '#41205A' },

        ]
      },
      // {
      //   name: 'bespoke',
      //   styles: [
      //     { themeVariable: '--cp-primary', value: '#41205A'},
      //     { themeVariable: '--cp-secondary', value: '#CE9F50'},
      //     { themeVariable: '--cp-gradient-v', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)'},
      //     { themeVariable: '--cp-gradient-h', value: 'linear-gradient(90deg, #FADB8D, #F2CF81, #CE9F50)'},
      //     { themeVariable: '--cp-gradient-bg', value: 'linear-gradient(200deg, #4a2267, #3a1e50, #1d0f29)'},
      //     { themeVariable: '--cp-bar', value: 'linear-gradient(0deg, #FADB8D, #F2CF81, #CE9F50)'},
      //     { themeVariable: '--cp-light', value: '#ffffff'},

      //     { themeVariable: '--cp-header', value: 'linear-gradient(200deg, #4a2267, #3a1e50, #1d0f29)'},
      //     { themeVariable: '--cp-dashboard', value: '#41205A'},
      //     { themeVariable: '--cp-footer', value: '#000'},
      //     { themeVariable: '--cp-subtext', value: '#fff'},
      //     { themeVariable: '--cp-active', value: '#70379B'},
      //     { themeVariable: '--cp-accordianHeader', value: 'transparent'},
      //     { themeVariable: '--cp-card1', value: 'transparent'},
      //     { themeVariable: '--cp-primary-default', value: '#41205A'},

      //   ]
      // },
      {
        name: 'solitaire',
        styles: [
          { themeVariable: '--cp-primary', value: '#2D2E84' },
          { themeVariable: '--cp-secondary', value: '#F2F9FD' },
          { themeVariable: '--cp-gradient-v', value: 'linear-gradient(0deg, #A8B0B5, #F2F9FD, #F2F9FD, #6C7175' },
          { themeVariable: '--cp-gradient-h', value: 'linear-gradient(90deg, #A8B0B5, #F2F9FD, #F2F9FD, #6C7175' },
          { themeVariable: '--cp-gradient-bg', value: 'linear-gradient(200deg, #2f4a9e, #2d2d83)' },
          { themeVariable: '--cp-bar', value: 'linear-gradient(90deg, #A8B0B5, #F2F9FD, #A8B0B5' },
          { themeVariable: '--cp-light', value: '#ffffff' },

          { themeVariable: '--cp-header', value: 'linear-gradient(200deg, #2f4a9e, #2d2d83)' },
          { themeVariable: '--cp-dashboard', value: '#2D2E84' },
          { themeVariable: '--cp-footer', value: '#000' },
          { themeVariable: '--cp-subtext', value: '#fff' },
          { themeVariable: '--cp-active', value: '#70379B' },
          { themeVariable: '--cp-accordianHeader', value: '#fff' },
          { themeVariable: '--cp-accordianHeader', value: 'transparent' },
          { themeVariable: '--cp-card1', value: 'transparent' },
          { themeVariable: '--cp-primary-default', value: '#2D2E84' },

        ]
      },
      {
        name: 'retailer',
        styles: [
          { themeVariable: '--cp-primary', value: '#E4001B' },
          { themeVariable: '--cp-secondary', value: '#F2F9FD' },
          { themeVariable: '--cp-gradient-v', value: 'linear-gradient(0deg, #A8B0B5, #F2F9FD, #F2F9FD, #6C7175' },
          { themeVariable: '--cp-gradient-h', value: 'linear-gradient(90deg, #A8B0B5, #F2F9FD, #F2F9FD, #6C7175' },
          { themeVariable: '--cp-gradient-bg', value: 'url("assets/imgs/maestro-bg.png")' },
          { themeVariable: '--cp-bar', value: 'linear-gradient(90deg, #A8B0B5, #F2F9FD, #A8B0B5' },
          { themeVariable: '--cp-light', value: '#ffffff' },

          { themeVariable: '--cp-header', value: '#E4001B' },
          { themeVariable: '--cp-dashboard', value: '#000' },
          { themeVariable: '--cp-footer', value: '#E4001B' },
          { themeVariable: '--cp-subtext', value: '#000' },
          { themeVariable: '--cp-active', value: '#fff' },
          { themeVariable: '--cp-accordianHeader', value: '#000' },
          { themeVariable: '--cp-card1', value: '#fff' },
          { themeVariable: '--cp-primary-default', value: '#000' },

        ]
      }
    ]

  }

  cycleTheme(): void {
    if (this.themes.length > this.currentTheme + 1) {
      this.currentTheme++;
    } else {
      this.currentTheme = 0;
    }

    this.setTheme(this.themes[this.currentTheme].name);
  }

  setTheme(name): void {
    let theme = this.themes.find(theme => theme.name === name);

    this.domCtrl.write(() => {
      theme.styles.forEach(style => {
        document.documentElement.style.setProperty(style.themeVariable, style.value);
      });
    });
  }

}
